import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(frontend)/not-found.tsx");
